<!--
 * @Author: guang
 * @Date: 2020-12-08 17:18:26
 * @LastEditTime: 2020-12-16 09:38:44
 * @LastEditors: guang
 * @Description:
-->
<template>
    <div>
        <div class="filter-bar">
            <p class="time" @click="calendarVisible = true">
                {{ startTime }} - {{ endTime }}
            </p>
            <div class="pay-select" @click="popupVisible = true">
                <span :class="{ 'default': !payType }">{{
                    payType || "支付方式"
                }}</span>
                <van-icon name="arrow-down" v-show="!payType"/>
                <van-icon name="cross" v-show="payType" @click="changePay($event)" />
            </div>
        </div>
        <div class="pay-popup" v-show="popupVisible" @click="popupVisible = false">
            <ul>
                <li
                    class="pay-method"
                    :class="{ active: item.value === params.payType }"
                    v-for="item in payList"
                    :key="item.value"
                    @click="changePay($event, item.value)"
                >
                    {{ item.title }}
                </li>
            </ul>
        </div>
        <calendar
            v-model="calendarVisible"
            :default-date="defaultDate"
            :min-date="new Date(2010)"
            :max-date="maxDate"
            :allow-same-day="true"
            color="#76B4FF"
            type="range"
            @confirm="changeDate"
        />
    </div>
</template>

<script>
import dayjs from "dayjs";
import { Calendar } from "vant";
export default {
    name: "Topbar",
    data() {
        return {
            popupVisible: false, // 支付方式弹窗
            calendarVisible: false, // 支付方式弹窗
            params: {
                startTime: dayjs().subtract(6, "day").format("YYYY-MM-DD"),
                endTime: dayjs().format("YYYY-MM-DD"),
                payType: ""
            },
            payList: Object.freeze([
                {
                    title: "微信支付",
                    value: "WXPAY"
                },
                // {
                //     title: "支付宝支付",
                //     value: "ALIPAY"
                // },
                {
                    title: "账期支付",
                    value: "SUPPLIER_PERIOD"
                },
                {
                    title: "预付款支付",
                    value: "ADVANCE"
                }
            ])
        };
    },
    components: {
        Calendar
    },
    computed: {
        startTime() {
            return dayjs(this.params.startTime).format("YYYY年MM月DD日");
        },
        endTime() {
            return dayjs(this.params.endTime).format("YYYY年MM月DD日");
        },
        payType() {
            return (
                this.payList.find((el) => {
                    return el.value === this.params.payType;
                }) || {}
            ).title;
        },
        maxDate() {
            return dayjs().add(2, "year").toDate();
        },
        defaultDate() {
            return [
                dayjs(this.params.startTime).toDate(),
                dayjs(this.params.endTime).toDate()
            ];
        }
    },
    beforeMount() {
        this.$emit("change", this.params);
    },
    methods: {
        changePay(e, value = "") {
            if (value === "") {
                e.stopPropagation();
            }
            this.params.payType = value;
            this.popupVisible = false;
            this.$emit("change", this.params);
        },
        changeDate(date) {
            const [start, end] = date;
            this.calendarVisible = false;
            this.params.startTime = dayjs(start).format("YYYY-MM-DD");
            this.params.endTime = dayjs(end).format("YYYY-MM-DD");
            this.$emit("change", this.params);
        }
    }
};
</script>

<style lang="less" scoped>
.filter-bar * {
    box-sizing: border-box;
}
.filter-bar {
    width: 100%;
    height: 52px;
    padding: 16px 12px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    .time {
        font-size: 14px;
        color: #333333;
    }
    .pay-select {
        width: 110px;
        height: 28px;
        background: #f8f8f8;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding: 0 12px;
        .default {
            color: #999999;
        }
        .allow-bottom {
            width: 12px;
            height: 12px;
            position: relative;
            &:after {
                border: solid 2px #c8c8cd;
                border-bottom-width: 0;
                border-left-width: 0;
                content: " ";
                top: 50%;
                left: 50%;
                position: absolute;
                width: 5px;
                height: 5px;
                transform: translate(-50%, -50%) rotate(135deg);
            }
        }
    }
}

.pay-popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    ul {
        position: absolute;
        background: #fff;
        top: 40px;
        right: 15px;
        width: 110px;
        font-size: 12px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.12);
        border: 1px solid #ededed;
    }
    .pay-method {
        height: 45px;
        width: 100%;
        box-sizing: border-box;
        line-height: 45px;
        color: #494949;
        padding: 0 12px;
        &:active {
            color: #73b0fa;
            background-color: #f6f8fa;
        }
        &.active {
            color: #73b0fa;
        }
        & + .pay-method {
            &:before {
                content: "";
                position: absolute;
                left: 12px;
                right: 12px;
                height: 0.5px;
                background: #ededed;
            }
        }
    }
}
</style>
